import React from "react";

const RankingTabs = ({ activeTab, setActiveTab }) => {
  // Tab configuration
  const tabs = [
    { id: "daily", label: "Xếp hạng theo ngày" },
    { id: "10days", label: "10 ngày" },
    { id: "20days", label: "20 ngày" },
    { id: "30days", label: "30 ngày" },
    { id: "monthly", label: "Xếp hạng theo tháng" },
  ];

  return (
    <div className="mb-6">
      <nav 
        className="flex flex-wrap gap-2 p-1 bg-gray-100 dark:bg-gray-800 rounded-lg shadow-inner" 
        aria-label="Tabs"
      >
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`
                relative px-6 py-3 rounded-lg font-semibold text-sm
                transition-all duration-300 ease-in-out
                transform hover:scale-105
                ${
                  isActive
                    ? "bg-purple-600 dark:bg-purple-600 text-white shadow-lg scale-105"
                    : "bg-transparent text-gray-600 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-700 hover:text-gray-900 dark:hover:text-gray-200"
                }
              `}
            >
              <span className="relative z-10">{tab.label}</span>
            </button>
          );
        })}
      </nav>
    </div>
  );
};

export default RankingTabs; 